import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Compensation")
], -1)
const _hoisted_5 = { class: "fv-row" }
const _hoisted_6 = { class: "d-flex flex-stack" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Will subjects receive gifts, payments, compensation, reimbursement, or extra credit for participating? ")
], -1)
const _hoisted_8 = { class: "form-check form-switch form-check-custom form-check-solid mb-7 me-4" }
const _hoisted_9 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Please explain")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_editor = _resolveComponent("editor")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("label", _hoisted_8, [
            _createVNode(_component_Field, {
              type: "checkbox",
              class: "form-check-input",
              name: "willSubjectsReceiveAnything",
              value: "1",
              modelValue: _ctx.step3.willSubjectsReceiveAnything,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step3.willSubjectsReceiveAnything) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.step3.willSubjectsReceiveAnything == "1" ? "Yes" : "No"), 1)
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_editor, {
          for: "receiveDetail",
          initialValue: "step3.receiveDetail",
          modelValue: _ctx.step3.receiveDetail,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step3.receiveDetail) = $event)),
          licenseKey: "gpl",
          "api-key": _ctx.currentEditorToken,
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "receiveDetail",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "How it will be record?",
          modelValue: _ctx.step3.receiveDetail,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step3.receiveDetail) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "receiveDetail",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ], 512), [
        [_vShow, _ctx.step3.willSubjectsReceiveAnything === '1']
      ])
    ])
  ]))
}